<template>
  <TaskCenter :menu="trees"></TaskCenter>
</template>

<script>
  import TaskCenter from '@/page/modules/task/index'
  export default {
    components: { TaskCenter },
    data () {
      return {
        trees: [
          {
            id: '01',
            name: '课程任务',
            component: '/continueEdu/taskList/course',
            className: 'task_kc_list'
          },
          {
            id: '02',
            name: '计划任务',
            component: '/continueEdu/taskList/plan',
            className: 'task_kaoshi_list'
          },
          {
            id: '03',
            name: '考试任务',
            component: '/continueEdu/taskList/exam',
            className: 'task_jihua_list'
          },
          {
            id: '04',
            name: '问卷任务',
            component: '/continueEdu/taskList/quiz',
            className: 'task_jihua_list'
          },
          {
            id: '05',
            name: '报名任务',
            component: '/continueEdu/taskList/enroll',
            className: 'task_kaoshi_list'
          }
        ]
      }
    }
  }
</script>

<style scoped>
  .online_bg { margin-top: 0; }
</style>



// WEBPACK FOOTER //
// src/page/continueEdu/task/index.vue